/* eslint-disable no-useless-escape */

export function cacheHtmlToWP(html: string): string {
    let result: string = html.replaceAll( `\\"`, WP_PARSE_HTML_QUOTE )
    return result
}

export function clearHtmlToWP(html: string): string {
    let result: string = html.replaceAll( WP_PARSE_HTML_QUOTE,  `\\"`)
    return result
}

export const WP_PARSE_HTML_QUOTE = "'"